export const SPAM_THREAD_LIST_ID = 'DEFAULT-7';